import React from 'react';
import { Card } from '../ui/Card';
interface KPIStripProps {
  metrics: {
    totalLeads: number;
    totalConverted: number;
    totalFunded: number;
  } | null;
}
export function KPIStrip({
  metrics
}: KPIStripProps) {
  if (!metrics) return null;
  const conversionRate = metrics.totalLeads > 0 ? (metrics.totalConverted / metrics.totalLeads * 100).toFixed(1) : '0.0';
  const fundedRate = metrics.totalLeads > 0 ? (metrics.totalFunded / metrics.totalLeads * 100).toFixed(1) : '0.0';
  const kpis = [{
    label: 'Leads Claimed',
    value: metrics.totalLeads.toLocaleString(),
    sub: 'Total cohort volume'
  }, {
    label: 'Converted to Opp',
    value: metrics.totalConverted.toLocaleString(),
    sub: `${conversionRate}% of claimed`
  }, {
    label: 'Funded Loans',
    value: metrics.totalFunded.toLocaleString(),
    sub: `${fundedRate}% pull-through`
  }, {
    label: 'Avg. Cycle Time',
    value: '24',
    valueSuffix: 'days',
    sub: 'Claimed to Funded'
  }];
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-52">
      {kpis.map(kpi => <Card key={kpi.label} className="p-5" data-id="element-53">
          <div className="text-xs font-medium uppercase tracking-wide text-[#706E6B] mb-3" data-id="element-54">
            {kpi.label}
          </div>
          <div className="text-3xl font-semibold tabular-nums text-[#181818] mb-1.5" data-id="element-55">
            {kpi.value}
            {kpi.valueSuffix && <span className="text-base font-normal text-[#706E6B] ml-1" data-id="element-56">
                {kpi.valueSuffix}
              </span>}
          </div>
          <div className="text-sm text-[#706E6B]" data-id="element-57">{kpi.sub}</div>
        </Card>)}
    </div>;
}